// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Curve } from 'recharts';

const CustomPieChartLabelLine = (props) => {
  const { percentage } = props;
  if (percentage < 2) return null;

  return <Curve {...props} type="linear" />;
};

CustomPieChartLabelLine.propTypes = {
  percentage: PropTypes.number.isRequired,
};

export default CustomPieChartLabelLine;
